// stores/auth.js
import { defineStore } from "pinia";
import { ref, watch } from "vue";

export const useKcseResultsStore = defineStore(
  "kcseResultsStore",
  () => {
    const results = ref(null);
    const userResults = ref([]);
    const allResults = ref([]);

    const searchQuery = ref("");
    const institutionSearchQuery = ref("");
    const showQualifiedCoursesOnly = ref(false);
    const selectedLevel = ref("Degree");
    const qualifiedCourses = ref([]);
    const qualifiedInstitutions = ref([]);
    const nonActiveSubscriptionResults = ref([]);
    const intendsToPaySubscription = ref(false);
    const automaticResultsEntry = ref(true);
    const showAll = ref(false);
    const freeToDateTime = ref(null);
    const programCategoryId = ref(null);
    const hasMoreResults = ref(true);
    const isLoadingMore = ref(false);
    const minNoOfSubscriptionDays = ref(2);
    const pricePerDay = ref(50);
    const hideHelp = ref(false);

    const hasActiveSubscription = ref(false);

    watch(hasActiveSubscription, (newVal) => {
      const freeDate = new Date(freeToDateTime.value); // Convert to Date if it's a string

      if (freeDate >= new Date()) {
        hasActiveSubscription.value = true;
      }
    });

    watch(
      results,
      (newVal) => {
        if (!newVal || !newVal.eligibleToDate) {
          hasActiveSubscription.value = false;
          showQualifiedCoursesOnly.value = false;
          return;
        }
        const eligibleDate = new Date(newVal.eligibleToDate);
        hasActiveSubscription.value =
          eligibleDate >= new Date() || freeToDateTime.value >= new Date();

        const freeDate = new Date(freeToDateTime.value); // Convert to Date if it's a string

        if (freeDate >= new Date()) {
          showQualifiedCoursesOnly.value = true;
        }
      },
      { deep: true }
    );

    function setResults(r) {
      if (r === null) {
        showQualifiedCoursesOnly.value = false;
      }
      results.value = r;
    }

    function addUniqueNonActiveSubscriptionResults(value) {
      nonActiveSubscriptionResults.value = [
        ...new Set([...nonActiveSubscriptionResults.value, value]),
      ];
    }

    function addUniqueQualifiedCourse(value) {
      qualifiedCourses.value = [...new Set([...qualifiedCourses.value, value])];
    }

    function addUniqueQualifiedInstitution(value) {
      qualifiedInstitutions.value = [
        ...new Set([...qualifiedInstitutions.value, value]),
      ];
    }

    return {
      results,
      setResults,
      userResults,
      searchQuery,
      showQualifiedCoursesOnly,
      selectedLevel,
      qualifiedCourses,
      qualifiedInstitutions,
      addUniqueQualifiedCourse,
      addUniqueQualifiedInstitution,
      hasActiveSubscription,
      nonActiveSubscriptionResults,
      addUniqueNonActiveSubscriptionResults,
      intendsToPaySubscription,
      automaticResultsEntry,
      allResults,
      showAll,
      freeToDateTime,
      hasMoreResults,
      isLoadingMore,
      minNoOfSubscriptionDays,
      programCategoryId,
      institutionSearchQuery,
      pricePerDay,
      hideHelp,
    };
  },
  {
    persist: true,
  }
);
